import { connect } from 'react-redux'
import requestToggleChecklistItem from '../../sagas/requestToggleChecklistItem'
import requestChangeChecklistItemName from '../../sagas/requestChangeChecklistItemName'
import requestRemoveChecklistItem from '../../sagas/requestRemoveChecklistItem'
import requestConvertChecklistItemToCard from '../../sagas/requestConvertChecklistItemToCard'
import requestConvertChecklistItemToSubCard from '../../sagas/requestConvertChecklistItemToSubCard'
import checklistItemSelector from './checklistItemSelector'
import ChecklistItem from './ChecklistItem'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  checklistItemSelector,
  {
    requestToggleChecklistItem,
    requestChangeChecklistItemName,
    requestRemoveChecklistItem,
    requestConvertChecklistItemToCard,
    requestConvertChecklistItemToSubCard
  },
  null,
  {
    forwardRef: true,
  }
)(ChecklistItem))
